<template>
	<div class="mail-sidebar-card bg-white p-3 border rounded-lg shadow-sm h-100">
        <!-- Compose Button -->
        <b-button
            v-if="checkPermission('message_store')"
            variant="primary"
            class="btn-compose w-100 py-2.5 px-4 mb-4 font-weight-bold d-flex align-items-center justify-content-center text-white shadow-sm"
            style="background-color: #2563eb; border-color: #2563eb; border-radius: 10px; font-size: 15px;"
            @click="$emit('newMessage')">
            <i class="ri-edit-line mr-2 h5 mb-0"></i> {{ $t('message_new') || 'Yeni Mesaj' }}
        </b-button>

        <!-- Navigation Menu -->
        <div class="mail-nav-list mb-4">
            <div
                class="mail-nav-item d-flex align-items-center justify-content-between px-3 py-2 rounded mb-1 cursor-pointer transition-all"
                :class="{ 'active': currentTab === 'inbox' }"
                @click="selectNav('inbox', 0)">
                <div class="d-flex align-items-center">
                    <i class="ri-mail-line mr-3 font-size-18 icon-muted"></i>
                    <span class="font-weight-medium">{{ $t('inbox') || 'Gelen Kutusu' }}</span>
                </div>
            </div>

            <div
                class="mail-nav-item d-flex align-items-center justify-content-between px-3 py-2 rounded mb-1 cursor-pointer transition-all"
                :class="{ 'active': currentTab === 'sent' }"
                @click="selectNav('sent', 1)">
                <div class="d-flex align-items-center">
                    <i class="ri-send-plane-line mr-3 font-size-18 icon-muted"></i>
                    <span class="font-weight-medium">{{ $t('outbox') || 'Giden Kutusu' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        currentBox: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            currentTab: 'inbox'
        }
    },
    methods: {
        selectNav(tabKey, boxIndex) {
            this.currentTab = tabKey;
            this.$emit('changeBox', boxIndex);
        }
    },

    watch: {
        currentBox(val) {
            if(val == 1) {
                this.currentTab = 'sent'
            }
        }
    }
}
</script>
<style scoped>
.btn-compose {
    background-color: #2563eb !important;
    border-color: #2563eb !important;
    transition: all 0.2s ease-in-out;
}
.btn-compose:hover {
    background-color: #1d4ed8 !important;
    border-color: #1d4ed8 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
}
.mail-nav-item {
    color: #475569;
    transition: all 0.15s ease-in-out;
    font-size: 14px;
}
.mail-nav-item:hover {
    background-color: #f1f5f9;
    color: #1e293b;
}
.mail-nav-item.active {
    background-color: #eff6ff;
    color: #2563eb;
    font-weight: 600 !important;
}
.mail-nav-item.active .icon-muted {
    color: #2563eb !important;
}
.icon-muted {
    color: #64748b;
}
.cursor-pointer {
    cursor: pointer;
}
</style>

